import { OrderProduct } from '../../../../entities/order-product/OrderProduct'
import DashboardActionTypes from './DashboardActionTypes'

export interface OpenConfirmDialog {
  type: DashboardActionTypes.OPEN_CONFIRM_DIALOG
  payload: {
    declinedProduct: OrderProduct
  }
}

export function openConfirmDialog(declinedProduct: OrderProduct): OpenConfirmDialog {
  return {
    type: DashboardActionTypes.OPEN_CONFIRM_DIALOG,
    payload: {
      declinedProduct,
    },
  }
}

export interface CloseConfirmDialog {
  type: DashboardActionTypes.CLOSE_CONFIRM_DIALOG
}

export function closeConfirmDialog(): CloseConfirmDialog {
  return {
    type: DashboardActionTypes.CLOSE_CONFIRM_DIALOG,
  }
}

export interface ConfirmAcceptDeclinedProduct {
  type: DashboardActionTypes.CONFIRM_ACCEPT_DECLINED_PRODUCT
  payload: {
    product: OrderProduct
  }
}

export function confirmAcceptDeclinedProduct(product: OrderProduct): ConfirmAcceptDeclinedProduct {
  return {
    type: DashboardActionTypes.CONFIRM_ACCEPT_DECLINED_PRODUCT,
    payload: {
      product,
    },
  }
}
